export default __webpack_public_path__ + "static/metaImage-ea602f7f71daa18102c949b12ddfb13e.jpg";